import React from "react";
import { useState } from "react";
import "./Navbar.css";
import logo from "./images/logo.png";
import { BrowserRouter } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link";
import { FaBars, FaInstagram, FaWhatsapp } from "react-icons/fa";

function Navbar() {
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const handleToggleMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  return (
    <BrowserRouter>
      <div className="navbar_outer">
        <div className="container navbar_container">
          {/* Hidden SVG for Instagram Gradient Definition */}
          <svg width="0" height="0" style={{ position: 'absolute', zIndex: -1 }}>
            <defs>
              <linearGradient id="instagram-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#f09433" /> {/* Orange */}
                <stop offset="25%" stopColor="#e6683c" /> {/* Darker Orange */}
                <stop offset="50%" stopColor="#dc2743" /> {/* Red */}
                <stop offset="75%" stopColor="#cc2366" /> {/* Purple-Red */}
                <stop offset="100%" stopColor="#bc1888" /> {/* Dark Purple */}
              </linearGradient>
            </defs>
          </svg>

          <nav className="main_nav">
            <div className="navbar_logo_wrapper">
              <img src={logo} alt="Final Tax Logo" className="navbar_logo_img" />
            </div>

            <div className="nav_links_center">
              <ul>
                <li>
                  <Link to="#" smooth>Home</Link>
                </li>
                <li>
                  <Link to="#about" smooth>About</Link>
                </li>
                <li>
                  <Link to="#services" smooth>Services</Link>
                </li>
                <li>
                  <Link to="#pricing" smooth>Pricing</Link>
                </li>
                <li>
                  <Link to="#consultation" smooth className="work_with_us_desktop_link">Work with us</Link>
                </li>
              </ul>
            </div>

            <div className="mobile_menu_toggle" onClick={handleToggleMenu}>
              <FaBars />
            </div>
          </nav>

          {/* Mobile Menu - UPDATED ORDER */}
          <div className={`mobile_menu_main ${showMobileMenu ? "show" : ""}`}>
            <ul>
              <li>
                <Link to="#" smooth>Home</Link>
              </li>
              <li>
                <Link to="#about" smooth>About</Link>
              </li>
              <li>
                <Link to="#services" smooth>Services</Link>
              </li>
              <li>
                <Link to="#pricing" smooth>Pricing</Link>
              </li>
              {/* MOVED: "Work with us" link here */}
              <li>
                <Link to="#consultation" smooth onClick={handleToggleMenu}>Work with us</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default Navbar;